"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LocationInfoCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const cancelable_promise_1 = require("cancelable-promise");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const Field_1 = __importDefault(require("../components/Field"));
const Loading_1 = __importDefault(require("../components/Loading"));
const UserContext_1 = require("../contexts/UserContext");
const react_i18next_1 = require("react-i18next");
const Employees_1 = __importDefault(require("../api/Employees"));
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
function LocationInfoCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState(null);
    const [locationInfo, setLocationInfo] = react_1.default.useState({
        locationCode: '',
        locationName: '',
        address1: '',
        address2: '',
        city: '',
        county: '',
        state: '',
        zip: '',
        geoCode: ''
    });
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => Employees_1.default.getLocationDetails(token, props.locationCode))).then((data) => {
            setLocationInfo(data);
            setStatus('done');
        }).catch((e) => {
            setLocationInfo(null);
            setStatus('error');
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('employees:text.locInfo') }), (status == 'done' && ((0, jsx_runtime_1.jsxs)(FadeInView_1.default, { style: { marginVertical: 0, marginHorizontal: 0, marginTop: 4 }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Regular.Buildings, size: 18, style: { marginRight: 12, alignSelf: 'center' } }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('employees:labels.locationName'), value: locationInfo.locationName }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Regular.IdBadge, size: 18, style: { marginRight: 12, alignSelf: 'center' } }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('employees:labels.locationCode'), value: locationInfo.locationCode }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Regular.LocationDot, size: 18, style: { marginRight: 12, alignSelf: 'center' } }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('profile:labels.address'), value: `${locationInfo.address1} ${locationInfo.address2} ${locationInfo.city}, ${locationInfo.state} ${locationInfo.zip} ${locationInfo.county} County`.replace(/\s+/g, ' ') }) })] })] }))) || (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() })] }));
}
